React = require 'react'
t = require('views/internal/recup-with-helpers')('paid_product_info')
track = require 'debug/track'
_ = require 'underscore'

module.exports = class extends React.Component
  displayName: 'PaidProductBannerComponent'

  constructor: (props) ->
    super props
    @state =
      inBoardLimitsTest: false

    @_boardLimitsPromise = null

  componentDidMount: ->
    if _.isFunction @props.getOrgBoardLimits
      @_boardLimitsPromise = @props.getOrgBoardLimits()
      .then (boardLimitsData) =>
        @setState
          inBoardLimitsTest: boardLimitsData.enabled

  componentWillUnmount: ->
    @_boardLimitsPromise?.cancel()

  render: t.renderable ->
    trackBCLink = ->
      track "Billing Page", "See All Benefits Link Click"
    { stringsKey, subtitleCount, infoUrl, epilogueCount, icon } = @props
    { inBoardLimitsTest } = @state

    t.div '.billing-intro.u-clearfix', ->

      t.div '.billing-intro-header', style: marginBottom: '25px', ->

        t.h1 '.billing-intro-header-title', ->
          t.format [stringsKey, 'title']
        for n in [0...subtitleCount]
          t.p '.billing-intro-header-text', ->
            t.format [stringsKey, 'subtitles', n]
        return

      t.ul class: t.classify('billing-intro-list': true, 'board-limits-experiment': inBoardLimitsTest ), ->
        # If you're in the experiment and you're on the 'normal' BC billing page we show an extra promo item
        features = if inBoardLimitsTest && stringsKey == 'business-class' then 4 else 3
        for n in [0...features]
          # If you're not in the test but you are on the 'normal' BC page
          # we need to skip the first 'Unlimited boards' promo item
          i = if !inBoardLimitsTest && stringsKey == 'business-class' then n + 1 else n
          t.li '.billing-intro-list-item', ->
            t.h3 ->
              t.format [stringsKey, 'featureHeaders', i]
            t.p ->
              t.format [stringsKey, 'featureBodies', i]
        return

      if epilogueCount
        t.div '.billing-intro-header', ->
          for n in [0...epilogueCount]
            t.p ->
              t.format [stringsKey, 'epilogue recent', n]
          return

      t.div '.billing-intro-more', ->
        t.a '.billing-intro-more-link.quiet-button',
          href: infoUrl
          target: '_blank'
          onClick: trackBCLink
        , ->
          t.format [stringsKey, 'link']



// WEBPACK FOOTER //
// ./app/scripts/views/ads/paid-product-banner-component.coffee